<template>
  <a-table size="middle" :pagination="false" :columns="columns" :data-source="tableData" row-key="release_id">
    <span slot="customerTitle" slot-scope="text, record">
      <a-tooltip placement="top" :title="record.release_title">
        <a class="custom-link" :href="releaseLink(record.release_id)" target="_blank"> {{ record.release_title }} </a>
      </a-tooltip>
    </span>
    <span slot="status" slot-scope="text, record">
      <a-badge :status="releaseStatus[record.status].status" :text="releaseStatus[record.status].label" />
    </span>
  </a-table>
</template>

<script>
import { releaseStatus } from '@/utils/dictionary';

const columns = [
  {
    width: 110,
    title: 'ID',
    dataIndex: 'release_id'
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    width: '8%',
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    width: '8%',
    title: '类型',
    dataIndex: 'release_type',
    customRender: text => text.label || '--'
  },
  {
    width: '8%',
    title: '环境',
    dataIndex: 'release_env',
    customRender: text => text.label || '--'
  },
  {
    width: '8%',
    title: '创建人',
    dataIndex: 'creator',
    align: 'center',
    customRender: text => text.nickname || '--'
  },
  {
    width: '15%',
    title: '创建时间',
    dataIndex: 'created_time'
  }
];
export default {
  name: 'WorkflowRelease',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      releaseStatus
    };
  },

  computed: {
    releaseLink() {
      return id => {
        const route = this.$router.resolve({
          name: 'page:project:workflow:release:detail',
          query: { releaseId: id }
        });
        return route.href;
      };
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 16px;
}
.ant-card {
  margin: 16px 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
  margin: -16px 32px 0 0;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}
</style>
